module.exports = __webpack_public_path__ + "assets/img/privacy-policy.29db8529.jpg";